module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vVQVEQ/tc-custom/9781504082860.jpg?1706271605631",
      "alt": "This image is the cover for the book Through Her Eyes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Through Her Eyes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“NJ Moss knows how to get inside your head with a story that will leave you reeling in its wake! Work of a genius.” —Amazon review"), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("This compelling new psychological thriller from the bestselling author of "), _c('i', [_vm._v("The Second Wife")]), _vm._v(" begs the question: "), _c('i', [_vm._v("How far would you go to save a stranger?")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Jess spends most of her time alone to hide her obsession: prowling the streets, looking into other people’s homes, sneaking glimpses of their private lives . . ."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" When Jess witnesses a man standing at the sink, washing blood off his hands and a woman, nearby, with a dejected expression, a simmering anger is unleashed. She may be a loner, but Jess won’t stand by when another woman is being abused, so she starts to make plans for a rescue. But what you see through a window frame is only ever part of the story, and Jess may be about to learn that you can’t always trust what you think you’ve seen . . .")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      NJ Moss\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0